@use '../../scss/utility';

@use './card-style-api';
@use './card-common';

:host {
  @include card-common.wb-card;
}

:host([interactive]) {
  @include card-common.wb-card-interactive;
}

:host([interactive]:hover) {
  @include card-common.wb-card-interactive-hover;
}

:host([interactive]:active) {
  @include card-common.wb-card-interactive-active;
}

:host([interactive]:focus) {
  @include card-common.wb-card-interactive-focus;
}

:host([interactive]:dir(rtl)) {
  @include card-common.wb-card-interactive-rtl;
}
